export const LOAD_PRODUCT_WITH_ID = 'LOAD_PRODUCT_WITH_ID';
export const PRODUCT_LOADED = 'PRODUCT_LOADED';
